import React from 'react';
import { Field, reduxForm } from 'redux-form/immutable';
import Button from '@material-ui/core/Button';
import RenderSelectField from "../inputs/renderSelectField";
import MenuItem from '@material-ui/core/MenuItem';
import RenderTextField from "../inputs/renderTextField";
import {_isAdmin} from "../../helpers/functions";

const ScoreRecordsFilterForm =  (props) =>{
  const {filterScoreRecords, handleSubmit, departments, handleCancel, personRoles} = props;
  return (
    <form onSubmit={handleSubmit(filterScoreRecords)}>
      {_isAdmin(personRoles) && (
        <div className={'form-group'}>
          <Field name="department" label={'Department'} component={RenderSelectField} fullWidth>
            {
              departments.map( department => (
                <MenuItem value={department.name} key={department.id}>{department.name}</MenuItem>
              ))
            }
          </Field>
        </div>
      )}
      <div className={'form-group'}>
        <Field name="type" label={'Type'} component={RenderSelectField} fullWidth>
          <MenuItem value={'Νέα'} >{'Νέα'}</MenuItem>
          <MenuItem value={'Υφιστάμενη'} >{'Υφιστάμενη'}</MenuItem>
          <MenuItem value={'Εξάμηνη'} >{'Εξάμηνη'}</MenuItem>
        </Field>
      </div>
      {_isAdmin(personRoles) && (
        <div className={'form-group'}>
          <Field name="email" label={'Email'} component={RenderTextField} type="text" fullWidth/>
        </div>
      )}
      <div className={'form-group'}>
        <Button type={'submit'} variant="contained" color="primary" className={'mr-3'}>
          {'Filter'}
        </Button>
        <Button onClick={handleCancel} variant="contained" color="secondary">
          {'Cancel'}
        </Button>
      </div>
    </form>
  )

};

export default reduxForm({
  form: 'scoreRecordsFilterForm',
})(ScoreRecordsFilterForm);



// WEBPACK FOOTER //
// ./src/components/scoreRecords/scoreRecordsFilterForm.js